import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Router} from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class PromotionService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    listGift(query?: any)
    {
       return this.get("/promotion/gifts",query);
    }

    createGift(body)
    {
        return this.post("/promotion/gifts", body);
    }

    updateGift(gift_id, body) {
        return this.put('/promotion/gifts/'+gift_id, body);
    }

    listExchange(query)
    {
        return this.get("/promotion/exchanges", query);
    }

    exchangeGift(body) {
        return this.post('/promotion/exchange-gift', body)
    }

}


// WEBPACK FOOTER //
// /app/src/app/common/services/Promotion.service.ts